import * as Icons from "@nova/component-icons"
import { useRef } from "react"
import { decidedAction, useDecisionModal, useDecisions } from "features/content-overlay/decision"
import DecisionModalContainer from "features/content-overlay/decision/DecisionModalContainer"
import {
    decisionProcessor,
    Decision,
    deleteLayerDecisionId,
} from "features/data-management/hotspots/editor/module"
import { useAppDispatch } from "integrations/redux/hooks"
import { useWorkspacePermissions } from "features/data-management/workspace/useWorkspacePermissions"
import { useUploadFlowContext } from "../useUploadFlowContext"
import { ButtonDestructive } from "@nova/component-btn"
import { clearSelection, setActiveFeatureId, setActiveLayerId } from "../../slice.new"

export const DeleteFlight = () => {
    const dispatch = useAppDispatch()
    const { isEditor } = useWorkspacePermissions()

    const { flightId, blurData, deleteFlight } = useUploadFlowContext()
    const ref = useRef<HTMLDivElement | null>(null)
    const yesAction = {
        ...decidedAction(Decision.Yes),
        meta: { label: "Delete Layer", cleanup: false },
    }

    const noAction = {
        ...decidedAction(Decision.No),
        meta: { label: "Cancel", cleanup: false },
    }
    const { needsDecision } = useDecisions(
        decisionProcessor({
            flightId,
            blurData: () => {
                dispatch(clearSelection())
                dispatch(setActiveLayerId({ id: undefined }))
                dispatch(setActiveFeatureId({ feature: undefined }))
                blurData()
            },
            deleteFlight,
        })
    )
    const { showSafely } = useDecisionModal(
        {
            id: deleteLayerDecisionId,
            title: "Delete this Layer?",
            description:
                "\nThis will delete the layer, do you want to proceed?\n\nThis <strong>cannot be undone</strong>.",
            options: [yesAction, noAction],
        },
        {
            fromWithinExistingModal: false,
        }
    )
    if (!isEditor) return null
    return (
        <div className="relative w-full" ref={ref}>
            <ButtonDestructive
                className="w-full !pl-3"
                LeftIcon={Icons.Trash}
                onClick={showSafely}
                isTransparent
            />
            {needsDecision && <DecisionModalContainer closeModal={() => dispatch(noAction)} />}
        </div>
    )
}
